import headerImgEn from "assets/images/v99/header-en.webp"
import infoImgEn from "assets/images/v99/info-en.webp"
import headerImgRu from "assets/images/v99/header-ru.webp"
import infoImgRu from "assets/images/v99/info-ru.webp"

export const v99ConfigImages: Record<string, Record<string, string>> = {
  header: {
    en: headerImgEn,
    ru: headerImgRu,
  },
  info: {
    en: infoImgEn,
    ru: infoImgRu,
  },
}
